import dayjs from 'dayjs'
import exportFromJSON from 'export-from-json'

import { ArticuloProps } from '../../../interfaces/articulo.ts'
import { ProveedorOperacionProps } from '../../../interfaces/proveedorOperacion.ts'

export const exportarArticulosCSV = async (data: ArticuloProps[], updateData: boolean): Promise<void> => {
  if (!data || data.length === 0) {
    throw new Error('NO se han encontrado registros.')
  }
  // Convert all string values to UTF-8 NFC to help with accents in CSV export
  const normalizeString = (value: string | null | undefined): string => {
    return typeof value === 'string' ? value.normalize('NFC') : value || ''
  }

  const forceExcelText = (value: string | null | undefined): string => {
    const normalized = typeof value === 'string' ? value.normalize('NFC') : value || ''
    if (!normalized) return ''

    // \u200B es un espacio de ancho cero (invisible)
    return '\u200B' + normalized
  }

  // Función auxiliar para extraer datos del proveedor de forma segura
  const extraerProveedor = (
    proveedor: ProveedorOperacionProps[] | ProveedorOperacionProps,
    campo: 'codigo' | 'nombre',
  ): string => {
    if (!proveedor) return ''
    if (Array.isArray(proveedor)) {
      return proveedor.map((p) => p[campo] || '').join(';')
    }
    // Si es un solo objeto, extraemos el campo. Si es string, lo devolvemos tal cual.
    return typeof proveedor === 'object' ? proveedor[campo] || '' : proveedor
  }

  const rows = data.map((articulo) => {
    if (updateData) {
      return {
        codigoArticulo: forceExcelText(articulo.codigoArticulo || '')
          .toString()
          .trim(),
        nombreArticulo: normalizeString(articulo.nombreArticulo || '').trim(),
        descripcionArticulo: normalizeString(articulo.descripcionArticulo || '').trim(),
        codigoActividad: normalizeString(articulo.sinProductoServicio?.codigoActividad || '').trim(),
        codigoSIN: normalizeString(articulo.sinProductoServicio.codigoProducto || ''),
        codigoProveedor: extraerProveedor(articulo.proveedor, 'codigo'),
        codigoTipoArticulo: normalizeString(articulo.tipoArticulo?.codigo || ''),
        claseArticulo: normalizeString(articulo.claseArticulo || ''),
        gestionArticulo: normalizeString(articulo.gestionArticulo || ''),
        tipoUnidadMedida: normalizeString(articulo.tipoUnidadMedida || ''),
        codigoUnidadRef: normalizeString(articulo.codigoUnidadRef || ''),
        articuloVenta: articulo.articuloVenta ? 'SI' : 'NO',
        articuloCompra: articulo.articuloCompra ? 'SI' : 'NO',
        articuloProduccion: articulo.articuloProduccion ? 'SI' : 'NO',
        verificarStock: articulo.verificarStock ? 'SI' : 'NO',
        activo: articulo.activo ? 'SI' : 'NO',
      }
    } else {
      return {
        codigoArticulo: normalizeString(articulo.codigoArticulo || ''),
        nombreArticulo: normalizeString(articulo.nombreArticulo || ''),
        descripcionArticulo: normalizeString(articulo.descripcionArticulo || ''),
        actividadEconomica: normalizeString(articulo.sinProductoServicio?.descripcionProducto || ''),
        codigoActividad: normalizeString(articulo.sinProductoServicio?.codigoActividad || ''),
        codigoSinProducto: normalizeString(articulo.sinProductoServicio.codigoProducto || ''),
        codigoTipoArticulo: normalizeString(articulo.tipoArticulo?.codigo || ''),
        tipoArticulo: normalizeString(articulo.tipoArticulo?.descripcion || ''),
        claseArticulo: normalizeString(articulo.claseArticulo || ''),
        gestionArticulo: normalizeString(articulo.gestionArticulo || ''),
        articuloCompra: articulo.articuloCompra ? 'SI' : 'NO',
        articuloVenta: articulo.articuloVenta ? 'SI' : 'NO',
        articuloProduccion: articulo.articuloProduccion ? 'SI' : 'NO',
        complemento: 'NO',
        verificarStock: articulo.verificarStock ? 'SI' : 'NO',
        activo: articulo.activo ? 'SI' : 'NO',
        estado: normalizeString(articulo.state || ''),
        codigoProveedor: extraerProveedor(articulo.proveedor, 'codigo'),
        proveedores: extraerProveedor(articulo.proveedor, 'nombre'),
      }
    }
  })

  const fileName = updateData
    ? `articulos_actualizar_${dayjs().format('YYYYMMDD_HHmmss')}`
    : `articulos_${dayjs().format('YYYYMMDD_HHmmss')}`
  const exportType = exportFromJSON.types.csv

  // Use a library like export-from-json to handle the export
  // Prepend UTF-8 BOM to ensure accents are recognized in Excel and other editors
  const options = {
    data: rows,
    fileName,
    exportType,
    withBOM: true,
    delimiter: ';' as const,
  }
  exportFromJSON(options)
}
